import { useRouterState } from '@tanstack/react-router'

/**
 * Returns the base path for the current workspace context.
 * e.g. "/app/startup/abc123" or "/app/investor/xyz456"
 */
export function useBasePath(): string {
  const pathname = useRouterState({ select: (s) => s.location.pathname })

  const match = pathname.match(/^\/app\/(startup|investor)\/([^/]+)/)
  if (match) {
    return `/app/${match[1]}/${match[2]}`
  }

  return '/app'
}
